<template>
    <v-container fluid class="fill-height">
        <v-row dense>
            <v-col cols="12" md="2">
                <v-select
                    v-model="classId"
                    :items="items"
                    label="选择班级"
                    hide-details
                    item-text="className"
                    item-value="id"
                    solo
                    @change="initialize"
                ></v-select>
            </v-col>
        </v-row>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row>
            <v-col>

                <div class="contain"  id="printTest" ref="dragContain">

                    <template v-for="(item,index) in dataPack.json">
                        <div class="drag"  v-if="dataPack.json.length"
                             :style="item.style">
                            {{item.text}}
                        </div>
                    </template>
                    <template v-for="(item,index) in dataSavePack.temporarySeat">
                        <div  class="drag"
                             :style="item.style">
                        </div>
                    </template>
                    <template v-for="(items,indexs) in dataPack.seats">
                        <template v-for="(item,index) in items">
                            <div class="drag"
                                 :style="item.style"
                                 @click="showDetailDialog(item.stuId)"
                            >
                                {{item.text}}
                            </div>
                        </template>
                    </template>
                </div>
            </v-col>
        </v-row>
        <v-dialog v-model="showDetail" max-width="1000px">
            <score-detail v-model="showDetail" :stuDetailMsg="stuDetailMsg"></score-detail>
        </v-dialog>
    </v-container>
</template>

<script>
    import arrayUtil from "@/utils/util/ArrayUtil"
    import scoreDetail from '../score/score-detail'

    export default {
        name: "RowOfSeats",
        data() {
            return {
                addMenu: false,
                dataPack: {
                    json: [],
                    students: [],
                    person: [],
                    seats: [],
                },
                dataSavePack: {
                    temporarySeat: [],
                    studentSeatCorrespondence: [],
                },
                stuDetailMsg: {},
                showDetail: false,
                //菜单位置
                x: 0,
                y: 0,
                //块位置
                offsetX: 0,
                offsetY: 0,
                //外层容器的宽高 数值不带px单位
                contain: {
                    xx: 500,
                    yy: 500
                },
                //记录原始位置
                originalLocation: {
                    left: 0,
                    top: 0
                },
                divindex: -1,//当前选中div的序号  默认为0
                nameIndex: -1,
                classId: '',
                className: '',
                stuCount: 0,
                legendColor: {
                    lastResult: '',
                    result: '',
                    lastRank: '',
                    rank: ''
                },
                transferStaff: {},
                items: [],
                overlay:false,
            }
        },
        async created() {
            this.overlay = true;
            this.classId = this.$route.params.classId;
            if (!this.classId) {
                this.$dialog.alert("请先选择班级");
                this.$router.push("/class");
            }
            this.$api.classList.getAllClass().then(data => {
                for (let i = 0; i < 5; i++) {
                    this.items.push(data.data[i]);
                }
            });
            await this.initialize();
        },
        methods: {
            async init() {
                const howManyInAColumn = 13;

                await this.$api.classList.getClassById(this.classId).then(data => {
                    this.className = data.data.className;
                    try {
                        this.dataPack.json = JSON.parse(data.data.classModel);
                    } catch (e) {
                        this.dataPack.json = null;
                    }
                    try {
                        this.dataSavePack = JSON.parse(data.data.seatSetting);
                    } catch (e) {
                        this.dataSavePack = null;
                    }
                    if (!this.dataSavePack) {
                        this.dataSavePack = {
                            temporarySeat: [],
                            studentSeatCorrespondence: [],
                        }
                    }
                    if (!this.dataPack.json || this.dataPack.json.length == 0) {
                        this.$api.bizClassRoom.selectClassRoom(data.data.classRoomId).then(data2 => {
                            this.dataPack.json = JSON.parse(data2.data.model);
                        });
                    }
                });

                await this.$api.achievement.getAchievement({
                    classId: this.classId
                }).then(data => {
                    let student = [];
                    this.stuCount = data.data.length;
                    for (let obj of data.data) {
                        let stu = {
                            id: obj.studentId,
                            name: obj.studentName,
                            school: obj.schoolNickName,
                            lastResult: obj.lastScoreStr,
                            result: obj.thisScoreStr,
                            rank: obj.thisRankStr,
                            lastRank: obj.lastRankStr,
                        };
                        student.push(stu);
                        if (obj.transferTimes > 0) {
                            this.transferStaff[obj.studentId] = obj.transferTimes;
                        }
                    }
                    let col = 0;
                    for (let i in student) {
                        let temp = {
                            "style": {
                                "width": "80px",
                                "height": "40px",
                                "fontSize": "18px",
                                "color": "#000",
                                "top": "560px",
                                "left": "1040px",
                                "border": "1px solid rgb(0, 0, 0)",
                                "backgroundColor": "rgb(255, 255, 255)",
                                "borderRadius": "5px",
                                lineHeight: "36px",
                                textAlign: "center"
                            }, "text": ""
                        };
                        temp.style.top = (parseInt(temp.style.height) + 20) * col + "px";
                        col = col++ > howManyInAColumn - 2 ? 0 : col;
                        temp.style.left = this.$refs.dragContain.offsetWidth + ((parseInt(temp.style.width) + 10) * (Math.floor(i / howManyInAColumn))) + 10 + "px";
                        temp.text = student[i].name;
                        Object.assign(student[i], temp);
                        this.dataPack.students.push(student[i])
                    }
                    let call = Math.ceil(this.dataPack.students.length / howManyInAColumn);

                    this.contain.xx = this.$refs.dragContain.offsetWidth + (call * 100);
                    this.contain.yy = this.$refs.dragContain.offsetHeight;
                })

                await this.$api.sysSetting.selectSetting("persontemplet").then(data => {
                    if (!data.data.v) {
                        this.$dialog.alert("请先设置人员模板");
                        this.$router.push("/PersonnelTemplate");
                    } else {
                        this.dataPack.person = JSON.parse(data.data.v);
                    }
                })
            },
            async initialize() {
                this.dataPack = {
                    json: [],
                    students: [],
                    person: [],
                    seats: [],
                };
                this.dataSavePack = {
                    temporarySeat: [],
                    studentSeatCorrespondence: [],
                };
                await this.init();
                for (let obj of this.dataPack.person) {
                    switch (obj.key) {
                        case "lastResult":
                            this.legendColor.lastResult = obj.style.color;
                            break;
                        case "result":
                            this.legendColor.result = obj.style.color;
                            break;
                        case "lastRank":
                            this.legendColor.lastRank = obj.style.color;
                            break;
                        case "rank":
                            this.legendColor.rank = obj.style.color;
                            break;
                    }
                }
                for (let obj of this.dataPack.json) {
                    switch (obj.key) {
                        case "stuCount":
                            obj.text = this.stuCount + "人";
                            break;
                        case "className":
                            obj.text = "ET" + this.className;
                            break;
                        case "lastResult":
                            obj.style.color = this.legendColor.lastResult;
                            break;
                        case "result":
                            obj.style.color = this.legendColor.result;
                            break;
                        case "lastRank":
                            obj.style.color = this.legendColor.lastRank;
                            break;
                        case "rank":
                            obj.style.color = this.legendColor.rank;
                            break;
                    }
                }
                for (let ssc of this.dataSavePack.studentSeatCorrespondence) {
                    let seat;
                    if (ssc.isTemp) {
                        seat = this.dataSavePack.temporarySeat[ssc.index];
                    } else {
                        seat = this.dataPack.json[ssc.index];
                    }
                    let nameIndex;
                    for (let obj in this.dataPack.students) {
                        if (this.dataPack.students[obj].id == ssc.stuId) {
                            nameIndex = obj;
                        }
                    }
                    let people = arrayUtil.deepClone(this.dataPack.person);
                    for (let obj of people) {
                        obj.style.top = parseInt(obj.style.top) + parseInt(seat.style.top) + "px";
                        obj.style.left = parseInt(obj.style.left) + parseInt(seat.style.left) + "px";
                        obj.text = this.dataPack.students[nameIndex][obj.key];
                        obj.stuId = this.dataPack.students[nameIndex].id;
                    }
                    this.dataPack.seats.push(people);
                }
                this.markTransfer();
                this.overlay = false;
            },
            clearSeat(index, num) {
                this.dataPack.seats.splice(index, 1);
                let i = -1;
                for (let j in this.dataSavePack.studentSeatCorrespondence) {
                    if (this.dataSavePack.studentSeatCorrespondence[j].stuId == num) {
                        i = j;
                        let ssc = this.dataSavePack.studentSeatCorrespondence[j];
                        if (!ssc.isTemp) {
                            this.dataPack.json[ssc.index].style.border = "1px solid rgb(0, 0, 0)";
                        } else {
                            this.dataSavePack.temporarySeat[ssc.index].style.border = "1px solid rgb(0, 0, 0)";
                        }
                        break;
                    }
                }
                this.dataSavePack.studentSeatCorrespondence.splice(i, 1);
            },

            isContinue(flag, index) {
                for (let ssc of this.dataSavePack.studentSeatCorrespondence) {
                    if (ssc.isTemp == flag) {
                        if (ssc.index == index) {
                            return true;
                        }
                    }
                }
                return false;
            },
            markTransfer() {
                for (let ssc of this.dataSavePack.studentSeatCorrespondence) {
                    if (this.transferStaff[ssc.stuId]) {
                        if (!ssc.isTemp) {
                            this.dataPack.json[ssc.index].style.border = "2px solid rgb(0, 0, 255)";
                        } else {
                            this.dataSavePack.temporarySeat[ssc.index].style.border = "2px solid rgb(0, 0, 255)";
                        }
                    }
                }
            },
            //用户详细弹窗
            showDetailDialog(id) {
                this.showDetail = true;
                this.stuDetailMsg.studentId = id;
            },
        },
        computed: {
            studentShow(stuId) {
                return function (stuId) {
                    if (this.dataSavePack.studentSeatCorrespondence.length == 0) return true;
                    for (let stu of this.dataSavePack.studentSeatCorrespondence) {
                        if (stu.stuId == stuId) {
                            return false
                        }
                    }
                    return true;
                }
            }
        },
        components:{
            scoreDetail
        }
    }
</script>

<style lang='scss' scoped>
    ul, li {
        margin: 0px;
        list-style: none;
        padding: 0px;
    }

    .contain {
        height: 209.8mm;
        position: relative;
        user-select: none;
        width: 297mm;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);
    }

    .el-form-item--mini.el-form-item {
        margin-bottom: 7px;
    }

    .drag {
        //width: 100px;
        //height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        cursor: move;
        background-color: red;
        border: 1px solid #FFF;
        //line-height: 1.7;
        box-sizing: border-box;
        color: #fff;
        overflow: hidden;
        //padding: 5px;

        .sacle {
            position: absolute;
            right: 0px;
            bottom: 0px;
            background-color: #909399;
            cursor: se-resize;
            font-size: 15px;
        }

        .del {
            position: absolute;
            top: 0px;
            right: 0px;
            padding: 2px;
            box-shadow: none;
        }
    }

    .drag.active {
        border-radius: 5px;
        border: 1px solid #85ce61;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.5);

    }

    .control {
        width: 250px;
        border-radius: 5px;
        overflow: hidden;
        background-color: #B3C0D1;
        position: absolute;
        z-index: 999;
        right: 20px;
        top: 15px;
    }
</style>

